export default "__VITE_PUBLIC_ASSET__ddf95018__"